import { css, html } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

/** CSS affecting the {@link HighScoreComponent} */
const styles: string = css`
:host {
    height: 10%;
    margin-bottom: 5%;
    overflow: hidden;
}
.highscore-component {
    height: 100%;
    overflow: hidden;
}
.highscore {
    overflow: hidden;
    box-sizing: border-box;
    height: 100%;
    background: rgba(41, 35, 35, 0.85);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    padding: 20px;
    overflow: auto;
    overflow-x: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.highscore h3 {
    text-align: center;
    margin-top: 10px;
    color: #fff;
    overflow: hidden;
}
.highscore-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: hidden;
}
.highscore-item {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 12px;
    color: #fff;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.2);
}
.highscore-item:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}
.no-highscores {
    text-align: center;
    color: #fff;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 20px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
}
.timer {
    overflow: hidden;
    text-align: center;
    color: #fff;
    font-size: 1.5rem;
}
`;

export class HighScoreComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    private _highScores: Array<{ player: string; time: number }> = [];
    private _elapsedSeconds: number = 0;

    public async connectedCallback(): Promise<void> {
        this.attachShadow({ mode: "open" });

        const storedElapsed: string | null = localStorage.getItem("elapsed_time");
        this._elapsedSeconds = storedElapsed ? parseInt(storedElapsed, 10) : 0;

        await this.render();
        this.updateTimerDisplay();

        this.startTimer();
    }

    /**
     * Start the timer
     */
    private startTimer(): void {
        setInterval(() => this.updateTimerDisplay(), 1000);
    }

    /**
     * Update the timer display
     */
    private updateTimerDisplay(): void {
        this._elapsedSeconds += 1;

        localStorage.setItem("elapsed_time", this._elapsedSeconds.toString());

        const minutes: number = Math.floor(this._elapsedSeconds / 60);
        const seconds: number = this._elapsedSeconds % 60;
        const formattedTime: string = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

        const timerElement: Element | null | undefined = this.shadowRoot?.querySelector(".timer");
        if (timerElement) {
            timerElement.textContent = `Time: ${formattedTime}`;
        }
    }

    /**
     * Handle the high score submission.
     */
    public async handleSubmitHighScore(playerName: string, timeTaken: number): Promise<void> {
        try {
            const minutes: number = Math.floor(timeTaken / 60000);
            const seconds: number = Math.floor((timeTaken % 60000) / 1000);
            const formattedTime: number = minutes * 60 + seconds;

            await this._gameRouteService.submitHighScore(playerName, formattedTime);
            await this.loadHighScores();
            void this.render();
            localStorage.removeItem("elapsed_time");
        }
        catch (error: unknown) {
            if (error instanceof Error) {
                console.error("Error submitting high score:", error.message);
            }
            else {
                console.error("Unknown error:", error);
            }
        }
    }

    /**
     * Render the high score component
     */
    public async render(): Promise<void> {
        await this.loadHighScores();
        const element: HTMLElement = this.renderHighScores();

        if (!this.shadowRoot) return;
        this.shadowRoot.innerHTML = "";
        this.shadowRoot.append(element);
    }

    /**
     * Load high scores from the game service
     */
    private async loadHighScores(): Promise<void> {
        try {
            const highScores: { scores: { player: string; time: number }[] } =
                await this._gameRouteService.getHighScores();
            this._highScores = highScores.scores;
        }
        catch (error) {
            console.error("Failed to load high scores:", error);
        }
    }

    /**
     * Render the high scores wrapper
     */
    private renderHighScores(): HTMLElement {
        return html`
            <div class="highscore-component">
                <style>${styles}</style>
                <div class="highscore">
                    <div class="highscore-list">
                        ${this._highScores.length === 0 ? this.renderNoHighScores() : this.renderScores()}
                    </div>
                    <div class="timer"></div>
                </div>
            </div>`;
    }

    /**
     * Render the high score values
     */
    private renderScores(): HTMLElement {
        // return this._highScores.map(
        //     score => html`
        //         <div class="highscore-item">
        //             <span>${score.player}</span>
        //             <span>${score.time}</span>
        //         </div>
        //     `
        // );
        return html`<div></div>`;
    }

    /**
     * Render message when no high scores exist
     */
    private renderNoHighScores(): HTMLElement {
        return html``;
    }

    /**
     * Handle the timer update event
     */
};
